import BaseAPI from "./BaseAPI";

class WPAPI extends BaseAPI {
	
    getById = (id) => {
        var promise = this.init().get("/account/wp/"+id);
        return promise;
    };

    getBaseInfo = (id) => {
        var promise = this.init().get("/account/wp/"+id+'/getBaseInfo');
        return promise;
    };

    update = (data) => {
        var promise = this.init().post("/account/wp/"+data.id, data);
        return promise;
    };

    getWorkprocesses = (data) => {
        var promise = this.init().post("/account/wp/search", data);
        return promise;
    };

    copyWorkprocesses = (data) => {
        var promise = this.init().post("/account/wp/copy", data);
        return promise;
    };
	
}

export default new WPAPI();